import { AxiosPromise } from 'axios'
import dayjs from 'dayjs'

import api from '@config/api'

interface IFilterProps {
  empresas: Array<number>
}

export function getStats({ empresas }: IFilterProps): AxiosPromise {
  return api.post('v1/Painel/Indicadores/Consolidado/Alertas', {
    empresasIds: empresas,
    dataInicio: dayjs().subtract(1, 'year').toISOString(),
    dataFim: dayjs().toISOString()
  })
}

export function getStatsFollowUp({ empresas }: IFilterProps): AxiosPromise {
  return api.post('v1/Painel/Indicadores/Consolidado/FollowUp', {
    empresasIds: empresas,
    dataInicio: dayjs().subtract(1, 'year').toISOString(),
    dataFim: dayjs().toISOString()
  })
}

export function getStatsFollowUpReab({ empresas }: IFilterProps): AxiosPromise {
  return api.post('v1/Painel/Indicadores/Consolidado/FollowUpReab', {
    empresasIds: empresas,
    dataInicio: dayjs().subtract(1, 'year').toISOString(),
    dataFim: dayjs().toISOString()
  })
}

export function getProcessDaily(): AxiosPromise {
  return api.get('v1/ProcessoDiario/obterProcessoDiario')
}

export function getSalesChart({ empresas }: IFilterProps): AxiosPromise {
  return api.post('v1/Painel/Grafico/Vendas', {
    empresasIds: empresas,
    dataInicio: dayjs().startOf('month').toISOString(),
    dataFim: dayjs().endOf('month').subtract(1, 'day').toISOString()
  })
}

export function getRuptureChart({ empresas }: IFilterProps): AxiosPromise {
  return api.post('v1/Painel/Grafico/Ruptura', {
    empresasIds: empresas
  })
}

export function getPurchaseOrdersChart({
  empresas
}: IFilterProps): AxiosPromise {
  return api.post('v1/Painel/Grafico/Pedidos', {
    empresasIds: empresas
  })
}

interface GetTableByEndpointOptionsProps {
  empresasIds?: any
  classificacao?: boolean
  listagem?: number
}

export function getTableByEndpoint(
  endpoint: string,
  {
    empresasIds = [],
    classificacao = undefined,
    listagem = undefined
  }: GetTableByEndpointOptionsProps
): AxiosPromise {
  return api.post('v1/Painel/' + endpoint, {
    empresasIds,
    classificacao,
    listagem
  })
}

export default {
  getStats,
  getStatsFollowUp,
  getProcessDaily,
  getSalesChart,
  getStatsFollowUpReab,
  getRuptureChart,
  getPurchaseOrdersChart,
  getTableByEndpoint
}
